import React, { FunctionComponent, ReactChild, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { IS_PRODUCTION, PRODUCT_TYPE, useFlags } from '@lyrahealth-inc/shared-app-logic'
import { LYRA_THEME_STORAGE_KEY, ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform'

import { logToSumoLogic, SUMO_CATEGORY } from '../../common/utils/userUtils'
import { getCustomerProductType } from '../../data/customer/customerSelectors'
import { getId } from '../../data/user/userSelectors'

export const ProductTypeProvider: FunctionComponent<{
  children: ReactChild | ReactChild[]
}> = ({ children }) => {
  const { isLyraSelectEnabled, isAuroraEnabled } = useFlags()
  const productType = useSelector(getCustomerProductType)
  const lyraId = useSelector(getId)
  const isLyraSelect = isLyraSelectEnabled && productType === PRODUCT_TYPE.SELECT

  const [essentialsTheme, setEssentialsTheme] = useState<string | null>(null)

  useEffect(() => {
    let storedTheme: string | null = null
    try {
      storedTheme = localStorage.getItem(LYRA_THEME_STORAGE_KEY)
    } catch (e) {
      console.error('Failed to read theme from localStorage', e)
      logToSumoLogic(IS_PRODUCTION ? SUMO_CATEGORY.PROD_DEBUG : SUMO_CATEGORY.STAGING_DEBUG, lyraId, {
        message: 'Failed to read theme from localStorage',
        type: 'error',
        error: e,
      })
    }
    const themeMode = storedTheme === 'dark' ? 'dark' : 'light'
    const userProductType = (isLyraSelectEnabled ? productType : undefined) ?? PRODUCT_TYPE.WFMH
    const themeName = isAuroraEnabled ? 'aurora' : userProductType.toLowerCase()
    setEssentialsTheme(`${themeName}_${themeMode}`)
  }, [isAuroraEnabled, isLyraSelectEnabled, lyraId, productType])

  return (
    <ProductTypeContext.Provider
      value={{
        isLyraSelect,
        productType: isLyraSelectEnabled ? productType : PRODUCT_TYPE.WFMH,
        isAuroraEnabled,
        essentialsTheme,
        setEssentialsTheme,
      }}
    >
      {children}
    </ProductTypeContext.Provider>
  )
}
